import { contractsService } from "../../api/contractsService/contractsService";
import { IsAuthorized } from "../../utils/helpers/auth";

export const getContractsData = async () => {
    if (IsAuthorized()) {
        const contractRes = await contractsService.getContracts();    

        if (contractRes.success) {
            return {
                contractsApi: !!contractRes.responseBody ? contractRes.responseBody.contracts : [],
            }
        } else {
            console.log('error');
        }
    } else {
        return {
            contractsApi: []
        }
    } 
}